import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface LeaderboardContextType {
  isLeaderboardOpen: boolean;
  openLeaderboard: () => void;
  closeLeaderboard: () => void;
}

const LeaderboardContext = createContext<LeaderboardContextType | undefined>(undefined);

export const useLeaderboardModal = () => {
  const context = useContext(LeaderboardContext);
  if (!context) {
    throw new Error('useLeaderboardModal must be used within LeaderboardProvider');
  }
  return context;
};

interface LeaderboardProviderProps {
  children: ReactNode;
}

export const LeaderboardProvider: React.FC<LeaderboardProviderProps> = ({ children }) => {
  const [isLeaderboardOpen, setIsLeaderboardOpen] = useState(false);

  const openLeaderboard = useCallback(() => {
    setIsLeaderboardOpen(true);
  }, []);

  const closeLeaderboard = useCallback(() => {
    setIsLeaderboardOpen(false);
  }, []);

  return (
    <LeaderboardContext.Provider value={{ isLeaderboardOpen, openLeaderboard, closeLeaderboard }}>
      {children}
    </LeaderboardContext.Provider>
  );
};
